import { WhiteLabel }        from "./utils/WhiteLabelProps";

WhiteLabel();
const REACT_APP_S3_BUCKET_NAME = sessionStorage.getItem('s3_bucket_name');

/*****************************************************************/
/* There are no AWS credentials here. They are only the id’s for the resources
   involved. And these resources cannot be accessed without authentication.
*/

export default {
    MAX_ATTACHMENT_SIZE: 10000000, // 10mb
    STRIPE_KEY: "",
    s3: {
        REGION: "us-west-2",
        // ASSESSMENT IMAGES & DOCUMENT IMAGES/FILES are saved in the below prod-documents bucket

        //  DEV  //
        //BUCKET: "training-slate-admin-dev-documents"

        //  PROD //
        BUCKET: "training-slate-admin-prod-documents" ///"+REACT_APP_S3_BUCKET_NAME, //Bucket for profile photos in another script: "training-slate-admin-prod-profile-photos"
    },

    /******************    PRODUCTION   ******************/
    apiGateway: {
        REGION: "us-west-2",
        URL: "https://ofna9b5mvf.execute-api.us-west-2.amazonaws.com/prod"
    },
    cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_POKwHe80B",
        APP_CLIENT_ID: "5r8cb817l29b5ud1mg94kvnnss",
        IDENTITY_POOL_ID: "us-west-2:0e9ebcd7-1123-413f-bfa9-9b2bc3aae62d"
    },

    /******************    DEVELOPMENT   ******************
    apiGateway: {
        REGION: "us-west-2",
        URL: "https://1aksm20lv1.execute-api.us-west-2.amazonaws.com/dev"
    },
    cognito: {
        REGION: "us-west-2",
        USER_POOL_ID: "us-west-2_9dcGdh5Oz",
        APP_CLIENT_ID: "6fnd1pmi6hn0j4q872jjkcld0j",
        IDENTITY_POOL_ID: "us-west-2:c9d67ee1-ecb3-455d-8ba0-d5567a9e9f6d"
    }
    /* END: DEV */
};



// WEBPACK FOOTER //
// ./src/config.js